import LivescoreFavoriteToggler from '@/components/atoms/LivescoreFavoriteToggler/LivescoreFavoriteToggler';
import { useLivescoreLayout } from '@/context/LivescoreLayoutContext';
import { useLivescoreMatch } from '@/context/LivescoreMatchContext';
import { cn } from '@/utils/cn';
import { convertAlpha, getCountryName } from '@/utils/countryCode';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';

const LivescoreMatchHeader = () => {
  const { match } = useLivescoreMatch();
  const { favoriteCompetitors, toggleMatchToFavorites, favoriteMatches } = useLivescoreLayout()

  const competitionName = match?.sport_event.sport_event_context?.competition?.name || '';
  const countryCode = match?.sport_event.sport_event_context?.competition?.category?.country_code || '';

  const alpha2 = countryCode ? convertAlpha(countryCode) : 'un';
  const countryName = countryCode ? getCountryName(countryCode) : 'Międzynarodowa';

  const hasFavoriteCompetitor =
    favoriteCompetitors.has(match.sport_event.competitors[0].id) ||
    favoriteCompetitors.has(match.sport_event.competitors[1].id);
  return (
    <header className="dark:bg-black-400 bg-white_theme-50 rounded-t-lg flex justify-between items-center">
      <div className='flex items-center gap-3'>
      <a href="/livescore">
        <span className="h-10 w-10 flex items-center justify-center dark:bg-gray-650 bg-white_theme-100 rounded-tl-lg">
          <ChevronLeftIcon width={16} height={16} className="dark:text-white text-black" />
        </span>
      </a>
      <div className="flex items-center gap-2">
        <div className="relative h-5 w-5 rounded-full overflow-hidden">
          <Image
            src={`https://flagcdn.com/${alpha2?.toLocaleLowerCase()}.svg`}
            alt={`Liga ${countryName ?? 'Międzynarodowa'}`}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <p className="text-xxs font-bold text-black dark:text-white">
          <span className="!font-medium text-gray-400 uppercase">{countryName}: </span>
          {competitionName}
        </p>
      </div>
      </div>
      <div className='flex items-center justify-center p-2'>
        <LivescoreFavoriteToggler
          className={cn(hasFavoriteCompetitor && 'cursor-default')}
          disabled={hasFavoriteCompetitor}
          onClick={() => toggleMatchToFavorites(match.sport_event.id)}
          isFavorite={favoriteMatches.has(match.sport_event.id) || hasFavoriteCompetitor}
          id={match.sport_event.id}
        />
      </div>
    </header>
  );
};

export default LivescoreMatchHeader;
